(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["we-signup-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('we-signup-preview');
    if (!dialog || dialog.dataset.weSignupReady) return;
    dialog.dataset.weSignupReady = 'true';
    const reopen = document.querySelector('.we-signup-preview__reopen');
    const backdrop = document.querySelector('.we-signup-preview__backdrop');
    const input = dialog.querySelector('input[type="email"]');
    const form = dialog.querySelector('#we-signup-form');
    const submit = form.querySelector('[type="submit"]');
    const result = dialog.querySelector('[data-we-signup-result]');
    const progress = dialog.querySelector('#we-signup-progress');
    const intro = dialog.querySelector('.we-signup-preview__intro');
    const terms = dialog.querySelector('.we-signup-preview__terms');
    const pendingKey = 'we_signup_pending_v2';
    let returnFocus = null;
    let submitting = false;
    let pending = false;
    let timer;
    const message = name => dialog.querySelector('[data-we-signup-message="' + name + '"]').content.textContent.trim();
    const showProgress = name => { if (progress) progress.textContent = message(name); };
    const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch {} };
    const openOffer = event => {
      returnFocus = event && event.currentTarget;
      // Non-modal placement lets Shopify's verification challenge appear above the offer.
      if (!dialog.open) dialog.show();
      backdrop.hidden = false;
      (result || input || dialog.querySelector('button')).focus();
    };
    try {
      reopen.hidden = sessionStorage.getItem('we_signup_dismissed_v1') !== '1';
      const saved = Number(sessionStorage.getItem(pendingKey));
      pending = saved > 0 && Date.now() - saved < 15 * 60 * 1000;
    } catch {}
    document.querySelectorAll('[data-we-signup-open], .we-signup-preview__reopen').forEach(button => button.addEventListener('click', openOffer));
    dialog.addEventListener('close', () => {
      backdrop.hidden = true;
      reopen.hidden = false;
      try { sessionStorage.setItem('we_signup_dismissed_v1', '1'); } catch {}
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
      else reopen.focus({ preventScroll: true });
    });
    dialog.querySelectorAll('.we-signup-preview__close, .we-signup-preview__dismiss').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('keydown', event => { if (event.key === 'Escape') dialog.close(); });
    if (input) {
      input.addEventListener('invalid', () => showProgress('invalid'));
      input.addEventListener('input', () => { if (!submitting && progress) progress.textContent = ''; });
    }
    form.addEventListener('submit', event => {
      // Shopify may resume submission after its verification; do not cancel that event.
      if (submitting || !submit) return;
      if (!navigator.onLine) { event.preventDefault(); showProgress('offline'); progress.focus(); return; }
      submitting = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      showProgress('submitting');
      try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch {}
      // Keep Shopify's native submission and any required verification intact.
      timer = setTimeout(() => {
        submitting = false;
        submit.disabled = false;
        form.removeAttribute('aria-busy');
        showProgress('unconfirmed');
      }, 60000);
    });
    window.addEventListener('pagehide', () => clearTimeout(timer));
    window.addEventListener('pageshow', event => {
      if (!event.persisted || !submitting) return;
      submitting = false;
      if (submit) submit.disabled = false;
      form.removeAttribute('aria-busy');
      showProgress('unconfirmed');
      clearPending();
    });
    // A returned server result remains visible even when browser storage is unavailable.
    const ownReturn = location.hash === '#we-signup-form';
    if (result && (pending || ownReturn)) {
      clearPending();
      if (result.dataset.weSignupResult === 'success') { intro.hidden = true; terms.hidden = true; }
      openOffer();
    } else if (pending) {
      clearPending();
      showProgress('unconfirmed');
      openOffer();
      if (progress) progress.focus();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
